import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { OtherTextResponse } from "../../models/responseData";
import { determineResponseTypeOtherTextResponse } from "../../utils/determineResponseType";
import { formatRouteText } from "../../navigation/utils";


const Subsection5b = () => {
  const [transformedResponse, setTransformedResponse] = useState<OtherTextResponse | null>(null);

  const { getAccessTokenSilently } = useAuth0();
  const { year, institution } = useParams();

  useEffect(() => {
    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section6/subsection5/other/?report_year=${year}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeOtherTextResponse(data)) {
        setTransformedResponse(data);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
  }, [getAccessTokenSilently, year]);

  return (
    <>
      <h2>Responses to “Other (please specify)”</h2>
      <h3>Which of the following is the most accurate statement about counteroffers from <span className="red-variable-name">{formatRouteText(institution)}</span>?</h3>
      {transformedResponse && transformedResponse.institution &&
        <>
          {transformedResponse.institution.length === 0 ? <>No text responses to display.</> :
            <ul>
              {transformedResponse.institution.map((response: string, i: number) =>
                <li key={i}>{response}</li>
              )}
            </ul>
          }
        </>
      }
      
    </>
  )
}

export default Subsection5b;